import { EventJournalQueries } from '@entities/eventJournal/model/queries';
import { DateHelpers } from '@shared/helpers';
import { useNuqsQueryState } from '@shared/hooks';

export const useCalendarQueries = () => {
    const { getPreviousSevenDays, dateFormatter } = DateHelpers;
    const { state: dateFromQueryValue, setState: setDateFromQueryValue } = useNuqsQueryState(
        EventJournalQueries.dateFrom
    );
    const { state: dateToQueryValue, setState: setDateToQueryValue } = useNuqsQueryState(
        EventJournalQueries.dateTo
    );

    const clearDateFrom = () => {
        void setDateFromQueryValue(null);
    };
    const clearDateTo = () => {
        void setDateToQueryValue(null);
    };
    const clearDateRangeQueryValues = () => {
        void setDateFromQueryValue(null);
        void setDateToQueryValue(null);
    };

    const setDateRangeQueryValues = (periodRange: [Date, Date]) => {
        const [start, end] = periodRange;
        void setDateFromQueryValue(dateFormatter({ date: start }));
        void setDateToQueryValue(dateFormatter({ date: end }));
    };
    const setDateRangeQueryValuesByDefault = () => {
        const [start, end] = getPreviousSevenDays();
        void setDateFromQueryValue(dateFormatter({ date: start }));
        void setDateToQueryValue(dateFormatter({ date: end }));
    };

    return {
        dateFromQueryValue,
        dateToQueryValue,
        clearDateRangeQueryValues,
        clearDateFrom,
        clearDateTo,
        setDateFromQueryValue,
        setDateToQueryValue,
        setDateRangeQueryValuesByDefault,
        setDateRangeQueryValues,
    };
};
